import { api } from '@/services'

export const fetchAll = async (params) => {
  return api.get('/admin/defaultServiceContract/search', { params })
}

export const show = async (defaultServiceValueId) => {
  return api.get(`/admin/defaultServiceContract/show/${defaultServiceValueId}`)
}

export const create = (body) => {
  return api.post('/admin/defaultServiceContract/create', body)
}

export const inactivate = (id) => {
  return api.post('/admin/defaultServiceContract/inactivate', {
    default_service_contract_ids: id,
  })
}
